import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';

import PrivacyPolicy from './components/PrivacyPolicy'
import PrivacyPolicyPage from './containers/PrivacyPolicyPage'
import PreviousPrivacyPolicy from './components/PreviousPrivacyPolicy'


const adsSideBarComponents = {
  GooglePublisherTag,
  AdvertWrapper
}

const privacyPolicyPageComponents = {
  PrivacyPolicy,
  ...adsSideBarComponents
}

const previousPrivacyPolicyComponents = {
  PreviousPrivacyPolicy,
  ...adsSideBarComponents
}

const PrivacyRoutes = (
    <div>
      <Route path="privacy" components={PrivacyPolicyPage}>
          <IndexRoute components={privacyPolicyPageComponents}/> {/*Has Layout*/}
      </Route>
      <Route path="privacy-previous" components={PrivacyPolicyPage}>
          <IndexRoute components={previousPrivacyPolicyComponents}/> {/*Has Layout*/}
      </Route>
    </div>
)

export default PrivacyRoutes



// WEBPACK FOOTER //
// ./modules/PrivacyPolicy/routes.js